import React from "react";
import LogoLight2x from "../../images/logo.svg";
import LogoDark2x from "../../images/logo-dark.svg";
import LogoSmall from "../../images/logo-big-img.png";

import {Link} from "react-router-dom";

const Logo = () => {
  return (
    <Link to={`${process.env.PUBLIC_URL}/`} className="logo-link">
      <img className="logo-dark logo-img mx-5" src={LogoDark2x} alt="logo" />
      <img className="logo-light logo-img mx-5" src={LogoLight2x} alt="logo" />
      <img className="logo-small logo-img logo-img-small" src={LogoSmall} alt="logo" />
    </Link>
  );
};

export default Logo;
